import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import HeaderOne from '../Header/HeaderOne'
import PageNotFound from '../PageNotFound'
import AdminUserDashboard from './AdminUserDashboard'
import AdminUserDashboardOrders from './AdminUserDashboardOrders'
import AdminUserDashboardReports from './AdminUserDashboardReports'

const AdminUserApp = ({ renderSweetAlert }) => {
  return (
    <>
      <div id="app-wrapper">
        <HeaderOne isAdminUserPath />
        <AdminUserDashboard>
          {({ activeCollection, collectionId, metabaseCollectionsLoading, metabaseCollectionsError, portalId }) => (
            <Switch>
              <Route
                exact
                path={['/admin/reports', '/admin/:portal_id/reports']}
                render={props => (
                  <AdminUserDashboardReports
                    key={`reports-${String(collectionId || 'none')}`}
                    {...props}
                    activeCollection={activeCollection}
                    collectionId={collectionId}
                    metabaseCollectionsLoading={metabaseCollectionsLoading}
                    metabaseCollectionsError={metabaseCollectionsError}
                  />
                )}
              />
              <Route
                exact
                path={['/admin', '/admin/orders', '/admin/:portal_id', '/admin/:portal_id/orders']}
                render={props => <AdminUserDashboardOrders {...props} portalId={portalId} />}
              />
              <Route component={PageNotFound} />
            </Switch>
          )}
        </AdminUserDashboard>
      </div>
      {renderSweetAlert()}
    </>
  )
}

AdminUserApp.propTypes = {
  renderSweetAlert: PropTypes.func.isRequired
}

export default AdminUserApp
